<template>
  <div style="display: flex;">
    <svg v-if="icon == 'news'" class="news-icon-svg" version="1.1" id="Icons" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 32 32" xml:space="preserve" width="100px" height="100px" fill="#000000" transform="matrix(-1, 0, 0, 1, 0, 0)">
      <g id="SVGRepo_bgCarrier" stroke-width="0"/>
      <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"/>
      <g id="SVGRepo_iconCarrier"> 
        <path class="st0" d="M22,6v18c0,1.6,1.3,3,3,3h0c1.6,0,3-1.3,3-3v-9l-6,0"/> 
        <path class="st0" d="M22,6v18c0,1.3,0.8,2.4,2,2.8V27H8H7c-1.7,0-3-1.4-3-3V6H22z"/> 
        <line class="st0" x1="8" y1="11" x2="14" y2="11"/> 
        <line class="st0" x1="8" y1="15" x2="10" y2="15"/> 
      </g>
    </svg>

    <svg v-else-if="icon == 'warn'" class="warning-icon-svg" width="100px" height="100px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="SVGRepo_bgCarrier" stroke-width="0"/>
      <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"/>
      <g id="SVGRepo_iconCarrier"> 
        <g clip-path="url(#clip0_949_22806)"> 
          <path d="M12 6.5C12.5523 6.5 13 6.94772 13 7.5L13 13.5C13 14.0523 12.5523 14.5 12 14.5C11.4477 14.5 11 14.0523 11 13.5L11 7.5C11 6.94772 11.4477 6.5 12 6.5Z" fill="#ffffff"/> 
          <path d="M12 18.5C12.8284 18.5 13.5 17.8284 13.5 17C13.5 16.1716 12.8284 15.5 12 15.5C11.1716 15.5 10.5 16.1716 10.5 17C10.5 17.8284 11.1716 18.5 12 18.5Z" fill="#ffffff"/> 
          <path fill-rule="evenodd" clip-rule="evenodd" d="M9.82664 2.22902C10.7938 0.590326 13.2063 0.590325 14.1735 2.22902L23.6599 18.3024C24.6578 19.9933 23.3638 22 21.4865 22H2.51362C0.63634 22 -0.657696 19.9933 0.340215 18.3024L9.82664 2.22902ZM12.4511 3.24557C12.2578 2.91814 11.7423 2.91814 11.549 3.24557L2.06261 19.319C1.90904 19.5792 2.07002 20 2.51362 20H21.4865C21.9301 20 22.0911 19.5792 21.9375 19.319L12.4511 3.24557Z" fill="#ffffff"/> 
        </g> 
        <defs> 
          <clipPath id="clip0_949_22806"> 
            <rect width="24" height="24" fill="white"/> 
          </clipPath> 
        </defs> 
      </g>
    </svg>

    <div v-else-if="icon == 'check'" class="check-icon-svg">
      <svg width="100px" height="100px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g id="SVGRepo_bgCarrier" stroke-width="0"/>
        <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"/>
        <g id="SVGRepo_iconCarrier"> 
          <path d="M4 12.6111L8.92308 17.5L20 6.5" stroke="#ffffff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/> 
        </g>
      </svg>
    </div>
  </div>
</template>

<script>
  export default {
    props:['icon']
  }
</script>

<style scoped lang="scss">
  .news-icon-svg {
    .st0{
      fill:none;
      stroke:#ffffff;
      stroke-width:2;
      stroke-linecap:round;
      stroke-linejoin:round;
      stroke-miterlimit:10;
    }
  }

  .check-icon-svg {
    border: 2px solid $cwhite;
    padding: 2px;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;

    svg {
      width: auto;
      height: 22px;
    }
  }
</style>